import calc from 'calculatorjs'
import { whsName } from '../filters/index'

/**
 * 计算是否可以使用優惠券，優惠金额，不可使用原因
 * @param {*} coupon
 * @param {*} param1
 */
export function discountInfo (coupon, {
  shippingRate,
  parcelsFeeFormulas,
  parcelsFee,
  weight,
  addrInfo,
  prepareModel,
  currency,
  oid,
}) {
  if (!parcelsFeeFormulas) {
    parcelsFeeFormulas = shippingRate?.parcelsFeeFormulas
  }
  if (parcelsFee === null || parcelsFee === undefined || parcelsFee === '' || !Number.isFinite(Number(parcelsFee))) {
    const parcelsFeeVersion = shippingRate?.oldParcelsFeeVersion || shippingRate?.parcelsFeeVersion
    if (parcelsFeeVersion === 'ShippingRateCalcTaxSplit' || parcelsFeeVersion === 'ShippingRateCalcTaxSplitAddl') {
      parcelsFee = (parcelsFeeFormulas?.fwFeesNoTax?.[4] || 0) + (parcelsFeeFormulas?.awFeesNoTax?.[4] || 0)
    } else {
      parcelsFee = shippingRate?.parcelsFee
    }
  }
  if (parcelsFeeFormulas?.srChgWeight) {
    weight = parcelsFeeFormulas.srChgWeight
  }
  const now = Date.now()

  let unable = ''
  // 超过使用次数
  if (coupon.cpnUsageMax !== '-1' && coupon.crUsage >= coupon.cpnUsageMax) {
    unable = 'usage'
  }
  // 已啟用并且已过期
  if (coupon.expiredTime > 0 && coupon.expiredTime * 1000 < now) {
    unable = 'expired'
  }
  if (coupon.activeTime > 0 && coupon.activeTime * 1000 > now) {
    unable = 'unavailable'
  }
  if (parcelsFeeFormulas?.cneeAddressDiscount) {
    return {
      canChose: false,
      message: '此券不適用於學生優惠。'
    }
  }
  if (unable && !oid) {
    let message = '已失效'
    if (unable === 'unavailable') {
      message = '尚未開放使用'
    }
    return {
      canChose: false,
      message
    }
  }
  if (coupon.expiredTime === '0') {
    return {
      canChose: false,
      message: '未啟用'
    }
  }
  if (coupon.cpnSrTransport !== 'all' && shippingRate.transport !== coupon.cpnSrTransport) {
    return {
      canChose: false,
      message: shippingRate.transport === 'air' ? '空運訂單不能使用' : '海快訂單不能使用'
    }
  }
  if (Number(coupon.cpnMinWeight) > weight) {
    return {
      canChose: false,
      // 不滿足使用條件：
      message: `集貨重量小於 ${coupon.cpnMinWeight / 1000} KG`
    }
  }

  if (currency === 'coin') {
    return {
      canChose: false,
      message: '此券不適用於金巧幣支付。'
    }
  }
  let discount = 0
  if (coupon.cpnOpr === 'sub') {
    discount = Number(coupon.cpnDiscount)
    if (discount >= parcelsFee) {
      return {
        canChose: false,
        // 不滿足使用條件：
        message: `運費金額低於${discount}台幣`
      }
    }
  }
  if (coupon.cpnOpr === 'mul') {
    if (coupon.cpnTarget === 'allWt') {
      discount = calc(`${parcelsFee}*(1-${coupon.cpnDiscount})`)
    } else if (coupon.cpnTarget === 'addlWt') {
      // 續重
      if (parcelsFeeFormulas?.calculationType === 'sea-aggregate') {
        return {
          canChose: false,
          message: '此券不適用海運聚合計費。'
        }
      }
      const awFee = parcelsFeeFormulas?.awFees?.[2] ?? parcelsFeeFormulas?.fwFees?.[2]
      if (!Number.isFinite(Number(awFee))) {
        return {
          canChose: false,
          message: '此券不適用目前的運費計算方式。'
        }
      }
      discount = calc(`${awFee}*${(weight - 1000) / 1000}*(1-${coupon.cpnDiscount})`)
    }
  }

  // if (shippingRate.addrid === '1210' || shippingRate.addrid === '1598') {
  //   return {
  //     canChose: false,
  //     message: '不適用經濟型海快。'
  //   }
  // }
  if (coupon.cpnWhsAddrid && coupon.cpnWhsAddrid !== '0' && coupon.cpnWhsAddrid !== shippingRate.addrid) {
    return {
      canChose: false,
      message: `此券僅供${whsName(coupon.cpnWhsAddrid)}使用。`
    }
  }

  // 商業件、企業申報人，特殊資費（蝦皮專享運費）不可用，經濟型海快 ECONOMY 可用
  if (coupon.cpnRules && coupon.cpnRules.invalidBiz === 'Y') {
    if (
      prepareModel.hasBizParcel ||
      (addrInfo && String(addrInfo.isCompany) === '1') ||
      shippingRate.srLabel === 'SHOPEE26' ||
      shippingRate.srLabel === 'ENT28'
    ) {
      return {
        canChose: false,
        message: '此券僅供個人集運件使用。'
      }
    }
  }

  if (shippingRate && shippingRate.srLabel === 'ENT1688' && coupon.cpnCode.indexOf('makeupsub') === -1 && coupon.cpnCode.indexOf('long91sub') === -1 && !coupon.cpnCode.startsWith('jypointsub')) {
    return {
      canChose: false,
      message: '此券僅不適用1688專案資費。'
    }
  }
  if (prepareModel?.parcelsInfo && coupon.cpnCode.indexOf('mgbizecosub') !== -1 &&
      (shippingRate.srLabel !== 'BIZECO' ||
      !prepareModel?.parcelsInfo.isAllPclDG1688)
  ) {
    return {
      canChose: false,
      message: '此券僅適用商業件經濟型海快1688代購包裹。'
    }
  }

  // 表示【商業件、企業申報人，經濟型海快、特殊資費（蝦皮專享運費）】不可用
  if (coupon.cpnRules && coupon.cpnRules.invalidBCEP === 'Y') {
    if (
      (prepareModel?.parcelsInfo.jyParcelBiz && shippingRate.transport !== 'sea') ||
      (addrInfo && String(addrInfo.isCompany) === '1') ||
      shippingRate.srLabel === 'ECONOMY' ||
      shippingRate.srLabel === 'ECONOMY-ALL' ||
      shippingRate.srLabel === 'SHOPEE26' ||
      shippingRate.srLabel === 'ENT28'
    ) {
      return {
        canChose: false,
        message: '此券僅供個人集運件使用，且不適用海運及經濟型海快。'
      }
    }
  }

  return {
    canChose: true,
    discount: Math.floor(discount),
  }
}

function getCouponSortGroup (coupon) {
  if (coupon.discountInfo?.canChose) {
    return 0
  }
  if (coupon.unable === 'unavailable') {
    return 2
  }
  if (coupon.unable === 'expired' || coupon.unable === 'usage' || coupon.expiredTime === '0') {
    return 3
  }
  return 1
}

function getCouponSortTime (coupon) {
  const timeKey = coupon.unable === 'unavailable' ? coupon.activeTime : coupon.expiredTime
  const time = Number(timeKey)
  if (!Number.isFinite(time) || time <= 0 || time === 1999999999) {
    return Number.MAX_SAFE_INTEGER
  }
  return time
}

export function sortCouponList (list = []) {
  return [...list].sort((a, b) => {
    const groupDiff = getCouponSortGroup(a) - getCouponSortGroup(b)
    if (groupDiff !== 0) return groupDiff

    const timeDiff = getCouponSortTime(a) - getCouponSortTime(b)
    if (timeDiff !== 0) return timeDiff

    return Number(b.discountInfo?.discount || 0) - Number(a.discountInfo?.discount || 0)
  })
}
